<template>
  <div class="space-pills">
    <ul class="space-pills--list">
      <li v-for="(item, i) in data" v-bind:key="i">
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SpacesPills',
  data: () => ({
  }),
  props: ['data'],
  components: {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.space-pills {
  margin: 0 0 20px 0;
}
.space-pills--list {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  font-size: 16px;
  li {
    list-style: none;
    padding: 3px 7px;
    border-radius: 4px;
    border: 1px solid $grey;
    line-height: 1.1;
    white-space: nowrap;
    text-transform: lowercase;
    text-overflow: ellipsis;
    position: relative;
    transition: all 0.3s ease-in-out;
    text-transform: capitalize;
  }
}
</style>
